import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
    selector: '[r1Draggable]',
})
export class DraggableDirective implements OnInit {
    readonly #_elementRef = inject(ElementRef);

    private element: any;

    constructor() {
        const _elementRef = this.#_elementRef;

        this.element = _elementRef.nativeElement;
    }

    ngOnInit() {
        this.element.draggable = true;
        this.element.addEventListener('dragstart', (event: any) => {
            const dataTransferData = event.target.outerHTML;
            event.dataTransfer.setData('field-merge-html', dataTransferData);
            event.dataTransfer.setData('is-drag-within', 'false');
            try {
                event.dataTransfer.setData('text/plain', '');
            } catch (err) {
                event.dataTransfer.setData('text', '');
            }
        });
    }
}
